import React, { useRef, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Link } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core'
import { useSnackbar } from 'notistack'

import {
  SearchRounded as SearchIcon,
  ExpandLessRounded as UpIcon,
  ExpandMoreRounded as DownIcon,
  FileCopyRounded as FileIcon,
  FindInPageRounded as InfoIcon,
} from '@material-ui/icons'

import { isArray, objLength } from '../../../utils/customMethods'
import Typography from '../../atoms/display/typography'
import IconButton from '../../atoms/inputs/iconButton'
import { setChatKeyword } from '../../../redux/keyword/actions'
import EmptyState from '../../atoms/display/emptyState'

import useStyles from './InsightsStyle'

const Insights = (props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const theme = useTheme()
  const classes = useStyles()
  const insights = useSelector((state) => state.insights)
  const activeConversation = useSelector((state) => state.activeConversation)
  const totalAnchorsRef = useRef(0)
  const currentAnchorRef = useRef(0)
  const { enqueueSnackbar } = useSnackbar()

  const search = (keyword) => {
    dispatch(setChatKeyword(keyword))
    setTimeout(() => {
      var x = document.getElementsByClassName(`anchor-chat`)
      for (var i = 0; i < x.length; i++) {
        x[i].style.backgroundColor = theme.palette.highlightSearch
      }
      if (x[0]) {
        x[0].style.backgroundColor = theme.palette.highlightSearchActive
        x[0].scrollIntoView()
      }
    }, 300)
  }

  const jumpToSearchAnchor = (moviment) => {
    var x = document.getElementsByClassName(`anchor-chat`)
    totalAnchorsRef.current = x.length
    for (var i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = theme.palette.highlightSearch
    }
    if (currentAnchorRef.current === 0 && moviment === 'up') {
      currentAnchorRef.current = x.length - 1
    } else if (
      currentAnchorRef.current === x.length - 1 &&
      moviment === 'down'
    ) {
      currentAnchorRef.current = 0
    } else {
      currentAnchorRef.current =
        moviment === 'up'
          ? currentAnchorRef.current - 1
          : currentAnchorRef.current + 1
    }
    if (x[currentAnchorRef.current]) {
      x[currentAnchorRef.current].style.backgroundColor =
        theme.palette.highlightSearchActive
      x[currentAnchorRef.current].scrollIntoView()
    }
  }

  const copyToClippboard = (string) => {
    navigator.clipboard.writeText(string).then(
      () => {
        enqueueSnackbar(`${t('commons.copied')}`, {
          variant: 'success',
        })
      },
      (err) => {
        console.error(t('commons.copiedError'), err)
      }
    )
  }

  const renderData = () => {
    const chatId = props?.chatId
      ? props.chatId
      : !props?.isHistoryNotes
      ? activeConversation
      : null

    return (
      <>
        {!objLength(insights.conversations[props?.chatId]) > 0 &&
        insights?.status?.get_insights?.loading ? (
          <div className={classes.loadingSection}>
            <CircularProgress size={25} color="primary" />
          </div>
        ) : objLength(insights?.conversations?.[chatId]) > 0 ? (
          <>
            {[...Object.values(insights?.conversations?.[chatId])].map((el) => {
              return !isArray(el) ? (
                <Link color="inherit" className={classes.cursor}>
                  {el}
                </Link>
              ) : (
                el.map((e) => (
                  <>
                    <div className={classes.itemRoom}>
                      <Typography variant="body1">{e}</Typography>
                      <div className={classes.itemButtons}>
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => {
                            search(e)
                          }}
                        >
                          <SearchIcon
                            size="small"
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: 14,
                              margin: 3,
                            }}
                          />
                        </IconButton>
                        <div style={{ width: 10 }} />
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => jumpToSearchAnchor('up')}
                        >
                          <UpIcon
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: 14,
                              margin: 3,
                            }}
                          />
                        </IconButton>
                        <div style={{ width: 10 }} />
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => jumpToSearchAnchor('down')}
                        >
                          <DownIcon
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: 14,
                              margin: 3,
                            }}
                          />
                        </IconButton>
                        <div style={{ width: 10 }} />
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => copyToClippboard(e)}
                        >
                          <FileIcon
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: 14,
                              margin: 3,
                            }}
                          />
                        </IconButton>
                      </div>
                    </div>
                  </>
                ))
              )
            })}
          </>
        ) : (
          <EmptyState text={t('alerts.noWordsCollected')}>
            <InfoIcon />
          </EmptyState>
        )}
      </>
    )
  }

  return (
    <>
      <div className={classes.content} style={{ padding: 5 }}>
        <table width="100%" cellPadding="10">
          <tbody>
            <tr>
              <td colSpan="2">{renderData()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}

export default memo(Insights)
